import { Menu } from 'lucide-react'
import { SemesterKiezer } from './SemesterKiezer'

export function Topbar({ onOpenSidebar }: { onOpenSidebar: () => void }) {
  return (
    <header className="glass sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-hairline px-4 lg:px-8">
      <button
        type="button"
        onClick={onOpenSidebar}
        className="btn-ghost -ml-2 h-9 w-9 p-0 lg:hidden"
        aria-label="Menu openen"
      >
        <Menu className="h-5 w-5" />
      </button>

      <span className="label-caps hidden sm:inline">Semester</span>
      <SemesterKiezer />
    </header>
  )
}
